module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAdCAYAAADLnm6HAAAA7UlEQVRIie3Vr0oGQRSG8d+M65+g9yDabCaDBoNNEDGI4GUIgtFmMJkErV6A8CXBos3wgc0LMYl6DLsLFm07U/YtE5/nwJz3pIhYxQNWlE3gOEXEBLuF4X3es/KT/85ixnVFgUmDK8xgH3P4HhiaOsYrTlNEDMz7P7kqfRQYBdB07zIOMY+vgZm5Y7zgscEGnrQdUDonKSKesVUBDp8ZS5Xg0GRcVBS46at4D0dYUPYTXo63YBQYBfpbsI0D7S0Yei2Sdg2nuG20HXA/MPSvrKWImGK9koCMj1pwRMZZRYHzvoo3sYPZQuDAG+5+APpsOtbVCZlzAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index-kind.png
// module id = tajm
// module chunks = 2